export const ImageTypes = {
  BACKGROUND_IMAGE_TYPE: 'background',
  COVER_IMAGE_TYPE: 'cover',
};
